import { connect } from 'react-redux';
import CourseContent from '../components/Course/Content';

export const mapStateToProps = ({ pages }, { pageId }) => ({ pageContent: pages[pageId] });

export default connect(mapStateToProps)(CourseContent);
